import React, { useState } from "react";
import { pollJobStatusControl } from "utils/pollJobStatusControl";
import ModalProcessing from "components/modal/ModalProcessing";

/**
 * Hook reutilizable que envuelve pollJobStatusControl con un modal informativo.
 * Retorna una funcion startPolling y un PollModalComponent para renderizar.
 *
 * @returns {{ startPolling: (token: string, jobStatusControlId: number|string, initialMessage?: string) => Promise<string>, PollModalComponent: JSX.Element }}
 */
export const usePollJobStatusControl = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const startPolling = (token, jobStatusControlId, initialMessage) => {
    setMessage(initialMessage || "Procesando...");
    setIsOpen(true);

    return pollJobStatusControl(token, jobStatusControlId)
      .then((result) => {
        setIsOpen(false);
        return result;
      })
      .catch((error) => {
        setIsOpen(false);
        throw error;
      });
  };

  const PollModalComponent = (
    <ModalProcessing isOpen={isOpen} message={message} />
  );

  return { startPolling, PollModalComponent };
};
